import { Injectable, computed, effect, signal } from '@angular/core';
import { MedicalRecordService } from './medical-record.service';
import { LoadingService } from 'src/app/shared/components/loading/loading.service';
import { MedicalTab, medicalTabs } from 'src/app/shared/components/tabs/tabs';
import { environment } from 'src/environments/environment';
import _ from 'lodash';
import { isMedicalTabKey } from 'src/app/shared/components/loading/loading-helpers';
import { MedicalRecordState } from '../store/medical-record.state';
import { Store } from '@ngrx/store';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { toSignal } from '@angular/core/rxjs-interop';
import { Maybe } from 'purify-ts';



@Injectable({
  providedIn: 'root'
})
export class TabsStateService {


  private readonly defaultTab = (environment.title === 'development' ? (localStorage.getItem('tab') ?? 'diagnóstico') : 'diagnóstico') as MedicalTab;
  private _currentTab = signal<MedicalTab>(this.defaultTab);
  public currentTab = this._currentTab.asReadonly()
  // authState = toSignal(this.store.select(getAuthStateSelect))


  // obs: terminar refatoração de tabs (que passa valores delas pra ingles) para implementar isso melhor
  // currentTabPermissions = computed( () => {
  //   const currentTab = this.currentTab()
  //   const authState = Maybe.fromNullable(this.authState());
  //   const permissions = authState.chainNullable( state => state.user?.permission )
  //   const currentPermission = permissions.chainNullable( permissions => permissions[''] )

  //   return authState.caseOf({
  //     Nothing: () => false,
  //     Just: val =>
  //   })
  // })

  // e = effect( () => {
  //   console.log(this.authState())
  // })

  constructor(
    private medicalRecordService: MedicalRecordService,
    private store: Store<MedicalRecordState>,
    private loadingService: LoadingService,

  ) {
    if (environment.title === 'development') {
      const defaultTab = localStorage.getItem('tab') as MedicalTab ?? this.defaultTab;
      this._currentTab.set(defaultTab);
    } else {
      this._currentTab.set(this.defaultTab);
    }
    const x = this.medicalRecordService.isMedicalRecordOpen
  }

  changeTab(newTab: MedicalTab) {
    this._currentTab.set(newTab)
  }


  currentTabState = computed( () => {
      const state = this.loadingService.loadingState();
      const tab = this._currentTab();
      return {
        get: !!state[`get-${tab}`],
        post: !!state[`post-${tab}`],
        put: !!state[`put-${tab}`],
        delete: !!state[`delete-${tab}`]
      }
  }, {equal : ( prev, next ) => {
    return prev.get == next.get &&
    prev.delete == next.delete &&
    prev.post == next.post &&
    prev.put == next.put
  }})

  // lista de medical tabs carregando algo
  medicalTabsLoading = computed( () => {
    const state = this.loadingService.loadingState();
    const pairsFromState = _.toPairs(state)

    const loadingMedicalTabsOnly = pairsFromState.filter( ( [key , value] ) => {
      const isMedical = isMedicalTabKey(key);
      if (!isMedical) {
        return false
      }
      return value
    })
    return loadingMedicalTabsOnly.map( ([key , value]) => key.split('-').pop())
  })



  // e2 = effect( () => {
  //   console.clear();
  //   console.log(_.toPairs(this.loadingService.loadingState()).filter( ([key, v]) => v ).map( ([key, v]) => key ) )
  // })


  // e = effect( () => {
  //   // const x = this.medicalRecordService.isMedicalRecordOpenSignal()
  //   // console.log({x})

  //   // const state = this.loadingService.loadingState();
  //   // const tab = this._currentTab();
  //   // const currentState = this.currentTabState()
  //   // console.clear()
  //   // console.log(currentState.get)
  // } )

}
